
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FAQKeyword from './FAQKeyword';
import Testimonials from './TestimonialKeyword';

function Corporateoutstation() {



    const cardData =
    {
        keyword: 'Corporate Cab and Bus Services for Outstation',
        heading: 'etravo :  Corporate Cab and Bus Services for Outstation',
        headingDescription: 'eTravo specializes in Corporate Cab and Bus Services for Outstation travel, providing businesses with seamless, safe, and comfortable intercity transportation. Whether it’s an executive visit, offsite meeting, training program, or corporate retreat, we offer well-maintained cabs and high-capacity buses to suit every need. Our services include experienced chauffeurs, business-class amenities, flexible scheduling, and real-time GPS tracking — all designed to ensure efficiency and peace of mind during long-distance travel. With eTravo, your outstation corporate journeys are always smooth, punctual, and professional.',

        top: 'Top Places to Visit in Pune with etravo',
"topPlaces": [
    {
      "title": "Shaniwar Wada",
      "description": "Built in 1732, Shaniwar Wada was the seat of the Peshwas of the Maratha Empire. Though much of the fort was destroyed by fire in 1828, the remaining structures, including the massive gates and foundations, offer a glimpse into its majestic past. The site is known for its architectural grandeur and the evening light and sound show that narrates its rich history."
    },
    {
      "title": "Aga Khan Palace",
      "description": "Constructed in 1892, the Aga Khan Palace is a significant monument in Indian history. It served as a prison for Mahatma Gandhi and his wife Kasturba Gandhi during the Quit India Movement. The palace is renowned for its Italian arches, sprawling lawns, and the memorials of Gandhi and Kasturba. It now houses a museum dedicated to Gandhi's life and work."
    },
    {
      "title": "Sinhagad Fort",
      "description": "Perched atop a hill about 30 km from Pune, Sinhagad Fort is a popular trekking destination. The fort has witnessed several battles, including the famous Battle of Sinhagad in 1670. Visitors can explore the ruins, enjoy panoramic views of the surrounding region, and savor local delicacies like 'pithla bhakri' sold by vendors at the summit."
    },
    {
      "title": "Dagdusheth Halwai Ganapati Temple",
      "description": "This temple is one of the most famous Ganesh temples in India. Known for its rich history and the grand Ganesh Festival celebrations, the temple attracts thousands of devotees and tourists annually."
    },
    {
      "title": "Osho Ashram",
      "description": "Located in Koregaon Park, the Osho International Meditation Resort is a tranquil haven for those seeking peace and spiritual growth. The ashram offers various meditation programs and workshops in a lush, serene environment."
    },
    {
      "title": "Raja Dinkar Kelkar Museum",
      "description": "This museum houses an extensive collection of over 20,000 artifacts, showcasing the everyday life of Indians in the past. From musical instruments and paintings to household items and sculptures, the museum offers a deep dive into India's rich cultural heritage."
    },
    {
      "title": "Pataleshwar Cave Temple",
      "description": "Dating back to the 8th century, the Pataleshwar Cave Temple is a rock-cut temple dedicated to Lord Shiva. Carved out of a single basalt rock, the temple features intricate carvings and a unique circular Nandi mandapa. It's a serene spot amidst the bustling city."
    },
    {
      "title": "Parvati Hill",
      "description": "Parvati Hill is one of the highest points in Pune, offering a panoramic view of the city. Atop the hill stands the Parvati Temple, dedicated to Goddess Parvati. The hill is a popular spot for morning walks and photography enthusiasts."
    },
    {
      "title": "Pune-Okayama Friendship Garden",
      "description": "Also known as Pu La Deshpande Garden, this is one of the largest Japanese-style gardens outside Japan. Inspired by the 300-year-old Okayama Korakuen Garden, it features manicured lawns, flowing streams, and picturesque bridges."
    },
    {
      "title": "Empress Garden",
      "description": "Spread over 39 acres, Empress Garden is a botanical garden known for its lush greenery, rare flora, and well-maintained lawns. It's a perfect spot for picnics, leisurely walks, and enjoying nature in the heart of the city."
    }
  ],
     "services": [
    {
      "name": "Outstation Corporate Cab & Bus Rental",
      "description": "eTravo provides reliable and flexible outstation corporate cab and bus rental services, designed for businesses that require long-distance travel for employees or executives. Whether it's a one-day trip or multi-day travel across cities, our fleet includes air-conditioned sedans, SUVs, mini-buses, and coaches to suit all business travel needs. All vehicles are equipped with GPS tracking and driven by trained professionals to ensure safety, punctuality, and comfort throughout the journey."
    },
    {
      "name": "Business Trip Transportation Services",
      "description": "Simplify outstation business trips with eTravo’s end-to-end transportation services. We handle everything from vehicle scheduling to on-road support, ensuring your team travels without hassle. Whether you're sending employees to client locations, regional offices, or training centers, our fleet of well-maintained, air-conditioned vehicles is ready for both individual and group business travel needs. Choose from hourly, daily, or trip-based packages that align with your business schedule."
    },
    {
      "name": "Corporate Bus Hire for Outstation Conferences",
      "description": "Attending a conference in another city? eTravo offers corporate bus hire for outstation conferences, ensuring your teams travel together in comfort and on time. Our buses are equipped with pushback seats, air-conditioning, luggage space, and entertainment systems, ideal for long journeys. We also provide route planning and backup vehicle support, making your event travel logistics seamless and worry-free."
    },
    {
      "name": "Outstation Employee Shuttle Services",
      "description": "eTravo’s outstation employee shuttle services are tailored for companies needing to move staff between offices, plants, or regional hubs. Our regular or on-demand shuttle plans ensure organized and timely transport for your employees. Each trip is coordinated by our support team with real-time tracking and emergency assistance, providing dependable transportation even across long distances."
    },
    {
      "name": "Corporate Event Travel Solutions",
      "description": "Organizing a corporate event outside the city? eTravo offers full-service corporate event travel solutions to manage transportation logistics from start to finish. We handle fleet planning, route mapping, group coordination, and vehicle management to transport your staff, guests, or partners comfortably. Whether for product launches, annual meets, or team offsites, we ensure timely arrival and premium service at every step."
    },
    {
      "name": "AC Buses and Cabs for Business Tours",
      "description": "Travel in comfort on your next business tour with eTravo’s AC buses and cabs. Whether you’re hosting executives or sending teams to field visits, our air-conditioned vehicles are perfect for extended travel. We offer customizable itineraries, multiple vehicle options, and professional chauffeurs to ensure every business tour is conducted with efficiency and professionalism."
    },
    {
      "name": "Luxury Transport for Corporate Retreats",
      "description": "Upgrade your corporate retreat experience with eTravo’s luxury transport options. We offer premium AC coaches, executive SUVs, and deluxe minibuses for business travel that demands style and comfort. Perfect for company retreats, leadership offsites, and team-building getaways, our luxury fleet comes with entertainment systems, plush seating, and personalized service to make your journey memorable."
    },
    {
      "name": "Affordable Corporate Outstation Bus Hire",
      "description": "Need to control costs while planning a corporate trip? eTravo offers affordable corporate outstation bus hire without compromising on comfort or reliability. Ideal for large groups, our budget-friendly AC buses are equipped with essential amenities and professional drivers. Whether it’s for training programs, outstation projects, or cross-city collaborations, we provide dependable transport at the right price."
    }
  ],
  "tableData": [
    ["Outstation Corporate Cab & Bus Rental", "Business Trip Transportation Services"],
    ["Corporate Bus Hire for Outstation Conferences", "Outstation Employee Shuttle Services"],
    ["Corporate Event Travel Solutions", "AC Buses and Cabs for Business Tours"],
    ["Luxury Transport for Corporate Retreats", "Affordable Corporate Outstation Bus Hire"]
  ],







"whychoose": [
    {
        "WhyChooseheading": "Reliable Outstation Travel You Can Count On",
        "WhyChoosedescription": "At eTravo, we specialize in dependable long-distance corporate cab and bus services. Whether you're organizing executive travel, corporate retreats, or outstation client visits, our team ensures your employees and associates reach their destination safely, punctually, and stress-free—no matter the distance."
    },
    {
        "WhyChooseheading": "Wide Range of Vehicles for Every Team Size",
        "WhyChoosedescription": "From executive sedans for one-on-one meetings to fully equipped AC buses for larger teams, eTravo offers a fleet suited for every corporate outstation travel scenario. Our vehicles are spacious, well-maintained, and loaded with comfort-enhancing features like reclining seats, charging ports, and ample legroom to make even the longest journeys pleasant."
    },
    {
        "WhyChooseheading": "Trained and Experienced Long-Distance Drivers",
        "WhyChoosedescription": "Long-distance travel demands expertise and focus, which is why all eTravo drivers undergo rigorous training for outstation routes. Our drivers are courteous, professional, and highly familiar with interstate highways and destination logistics, ensuring smooth navigation and safe arrival every time."
    },
    {
        "WhyChooseheading": "Upfront Pricing with No Surprises",
        "WhyChoosedescription": "Planning outstation corporate travel is easier when you know exactly what you're paying for. With eTravo, you receive transparent and all-inclusive pricing with no hidden fees. We offer fixed quotes based on distance, vehicle type, and trip duration—perfect for budgeting and business travel approvals."
    },
    {
        "WhyChooseheading": "Enhanced Safety for Long-Distance Journeys",
        "WhyChoosedescription": "Safety is especially critical for outstation trips. Our vehicles are fitted with GPS tracking, emergency contact systems, first-aid kits, and seat belts for all passengers. We also follow strict maintenance schedules and perform pre-trip safety checks to ensure each journey is risk-free and compliant with travel regulations."
    },
    {
        "WhyChooseheading": "24/7 Customer Support and Route Assistance",
        "WhyChoosedescription": "Corporate trips often involve changing plans and unpredictable schedules. eTravo offers around-the-clock support for real-time travel assistance, last-minute route changes, and immediate driver communication. Our goal is to provide total peace of mind throughout your outstation journey."
    },
    {
        "WhyChooseheading": "Seamless Booking and Real-Time Coordination",
        "WhyChoosedescription": "Book your outstation corporate travel easily through our website or mobile platform. You’ll receive real-time trip tracking, status updates, and route progress. Our backend team ensures that every detail is managed efficiently so your team can focus on business, not logistics."
    },
    {
        "WhyChooseheading": "Custom Travel Plans Tailored to Business Needs",
        "WhyChoosedescription": "Whether it’s a one-day meeting in a nearby city or a multi-day offsite retreat, eTravo builds flexible corporate travel packages that fit your schedule, preferences, and company policies. Tell us your destination and travel goals, and we’ll take care of everything—from vehicle allocation to route planning."
    }
]





















    }


   



// Corporate Cab and Bus Services for Outstation – eTravo

const faqData = [
    [
        {
            question: 'Does eTravo provide corporate cab and bus services for outstation travel?',
            answer: 'Yes, eTravo offers reliable outstation travel solutions for corporate clients, including executive cab services and comfortable AC buses for team travel to destinations outside the city.',
        },
        {
            question: 'Can we book outstation transport for corporate events or business trips?',
            answer: 'Absolutely. Whether it’s a business conference, site visit, or team offsite, eTravo provides fully managed outstation travel with route planning, vehicle coordination, and 24/7 support.',
        },
        {
            question: 'What vehicle options are available for corporate outstation travel?',
            answer: 'We offer premium sedans, SUVs, tempo travellers, and luxury buses, depending on the group size and comfort needs. All vehicles are driven by experienced chauffeurs familiar with long-distance routes.',
        },
        {
            question: 'Does eTravo offer round-trip and multi-day booking options?',
            answer: 'Yes, eTravo supports one-way, round-trip, and multi-day bookings for outstation corporate travel. You can customize the travel plan based on your itinerary and accommodation schedules.',
        },
        {
            question: 'Are tracking and reporting features available during outstation trips?',
            answer: 'Yes. All trips are GPS-tracked in real time, and clients receive travel updates, driver details, and journey summaries. Our operations team monitors trips to ensure safety and punctuality.',
        },
        {
            question: 'Is there corporate support available during the entire outstation journey?',
            answer: 'Yes, eTravo assigns a dedicated coordinator for each outstation trip to manage communication, itinerary adjustments, and emergency support throughout the journey.',
        },
    ]
];

const testimonialsData = [
    {
        name: 'Mr. Rajeev Mehta',
        designation: 'Logistics Manager, OrionTech',
        rating: [1, 1, 1, 1, 1],
        text: '“We used eTravo for a multi-city corporate visit. Their buses were comfortable and well-equipped, and the service was professionally handled from start to finish. Perfect for outstation corporate travel.”',
    },
    {
        name: 'Ms. Deepali Gokhale',
        designation: 'Admin Executive, Zenix Pharma',
        rating: [1, 1, 1, 1, 1],
        text: '“Our leadership team traveled outstation with eTravo and was very pleased with the vehicles and service quality. The team handled route planning, comfort, and punctuality with excellence.”',
    },
];






















    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9356411908",
            "+91 8600135991",

        ],
        email: "booking@etravo.in"
    };


    const Images = [
    {
        place: "/images/keyword/1.png",
        text: "Corporate Bus Services Pune",
        link: "/Corporate-Bus-Services-Pune"
    },
    {
        place: "/images/keyword/2.png",
        text: " Corporate Cab and Bus Service in Ahmednagar",
        link: "/Corporate-Cab-and-Bus-Service-in-Ahmednagar"
    },
    {
        place: "/images/keyword/3.png",
        text: " Corporate Cab and Bus Service in Amravati",
        link: "/Corporate-Cab-and-Bus-Service-in-Amravati"
    },
    {
        place: "/images/keyword/4.png",
        text: " Corporate Cab and Bus Service in Kolhapur",
        link: "/Corporate-Cab-and-Bus-Service-in-Kolhapur"
    },
    {
        place: "/images/keyword/5.png",
        text: " Corporate Cab and Bus Service in Sangli",
        link: "/Corporate-Cab-and-Bus-Service-in-Sangli"
    },
    {
        place: "/images/keyword/6.png",
        text: " Corporate Cab and Bus Service in Satara",
        link: "/Corporate-Cab-and-Bus-Service-in-Satara"
    },
    {
        place: "/images/keyword/7.png",
        text: " Corporate Cab and Bus Services for Outstation",
        link: "/Corporate-Cab-and-Bus-Services-for-Outstation"
    },
    {
        place: "/images/keyword/8.png",
        text: " Corporate Cab and Bus Services in Aundh",
        link: "/Corporate-Cab-and-Bus-Services-in-Aundh"
    },
    {
        place: "/images/keyword/9.png",
        text: " Corporate Cab and Bus Services in Aurangabad",
        link: "/Corporate-Cab-and-Bus-Services-in-Aurangabad"
    },
    {
        place: "/images/keyword/10.png",
        text: " Corporate Cab and Bus Services in Bhosari MIDC",
        link: "/Corporate-Cab-and-Bus-Services-in-Bhosari-MIDC"
    },
    {
        place: "/images/keyword/11.png",
        text: " Corporate Cab and Bus Services in Hadapsar",
        link: "/Corporate-Cab-and-Bus-Services-in-Hadapsar"
    },
    {
        place: "/images/keyword/12.png",
        text: " Corporate Cab and Bus Services in Hinjewadi",
        link: "/Corporate-Cab-and-Bus-Services-in-Hinjewadi"
    },
    {
        place: "/images/keyword/13.png",
        text: " Cab Services For corporate Travellers in Mumbai",
        link: "/Cab-Services-For-corporate-Travellers-in-Mumbai"
    },
    {
        place: "/images/keyword/14.png",
        text: " Corporate Cab and Bus Services in Nashik",
        link: "/Corporate-Cab-and-Bus-Services-in-Nashik"
    },
    {
        place: "/images/keyword/15.png",
        text: "Corporate Cab and Bus Services in Pune",
        link: "/Corporate-Cab-and-Bus-Services-in-Pune"
    },
    {
        place: "/images/keyword/16.png",
        text: "Corporate Cab and Bus Services in Sanaswadi",
        link: "/Corporate-Cab-and-Bus-Services-in-Sanaswadi"
    },
    {
        place: "/images/keyword/17.png",
        text: " Corporate Cab and Bus Services in Shirwal MIDC",
        link: "/Corporate-Cab-and-Bus-Services-in-Shirwal-MIDC"
    },
    {
        place: "/images/keyword/18.png",
        text: " Corporate Cab and Bus Services in Solapur",
        link: "/Corporate-Cab-and-Bus-Services-in-Solapur"
    },
    {
        place: "/images/keyword/19.png",
        text: " Corporate Cab and Bus Services in Talwade MIDC",
        link: "/Corporate-Cab-and-Bus-Services-in-Talwade-MIDC"
    },
    {
        place: "/images/keyword/20.png",
        text: "  Corporate Cab and Bus Services Pune Airport",
        link: "/Corporate-Cab-and-Bus-Services-Pune-Airport"
    },
    {
        place: "/images/keyword/21.png",
        text: " Corporate Cabs and Bus in Ranjangaon MIDC",
        link: "/Corporate-Cabs-and-Bus-in-Ranjangaon-MIDC"
    },
    {
        place: "/images/keyword/22.png",
        text: " Corporate Cabs and Bus Services in Chakan",
        link: "/Corporate-Cabs-and-Bus-Services-in-Chakan"
    },
    {
        place: "/images/keyword/23.png",
        text: " Corporate Cabs and Bus Services in Nagpur",
        link: "/Corporate-Cabs-and-Bus-Services-in-Nagpur"
    },
    {
        place: "/images/keyword/24.png",
        text: "  One Way Cab Services Mumbai to Pune Drop",
        link: "/One-Way-Cab-Services-Mumbai-to-Pune-Drop"
    },
];



    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];







const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Corporate Cab and Bus Services for Outstation",
  "image": "https://www.etravo.in/images/keyword/corporate-cab-bus-service-outstation.jpg",
  "description": "Book corporate cab and bus services for outstation travel with eTravo. Perfect for business trips, conferences, corporate retreats, and employee shuttle services. Luxury and affordable AC buses and cabs available for reliable outstation transportation.",
  "brand": {
    "@type": "Brand",
    "name": "eTravo"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "2950"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "3499",
    "availability": "https://schema.org/InStock",
    "url": "https://www.etravo.in/corporate-cab-and-bus-services-for-outstation"
  }
};




    return (
        <div>

<Helmet>
  <title>Corporate Cab and Bus Services for Outstation | Business Travel & Retreats | eTravo</title>
  <meta 
    name="description" 
    content="Hire corporate cab and bus services for outstation business trips and corporate retreats with eTravo. AC vehicles, luxury options, and affordable pricing for reliable outstation transport." 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

            <section
                className="page-title"
                style={{ backgroundImage: 'url(images/background/3.jpg)' }}
            >
                <div className="auto-container">
                    <h1>{cardData.keyword}</h1>
                    <div className="bread-crumb-outer">

                    </div>
                </div>
            </section>




            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                {/* <h1 className='text-white'>{cardData.keyword}</h1> */}
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/7.png' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#008000', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For eTravo</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                <FAQKeyword faqs={faqData} />

                                                
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Testimonials testimonials={testimonialsData} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e, index) => (
    <div className="box1 d-flex justify-content-around align-items-center" key={index}>
        <div className="b1">
            <a href={e.link}>
                <img src={e.place} alt={e.text.trim()} />
            </a>
        </div>
        <div className="b2 px-3">
            <a href={e.link} >
                {e.text.trim()}
            </a>
        </div>
    </div>
))}


                            <div className="gallery-container">
                               <h2 className="gallery-title d-none">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #008000',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#008000' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+919356411908" className="d-block  text-white">+91 9356411908</a>
                                                <a href="tel:+918600135991" className="d-block  text-white">+91 8600135991</a>



                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#008000' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Email</h4>
                                                <a href="mailto:booking@etravo.in" className=" text-white d-block">
                                                    booking@etravo.in
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#008000' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> etravo  <br />
                                                       Office No.231 & 232 Ganesh Galaxy Near Ashoka Hotel Alandi Pune road wadhmukhwadi - 412105
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Corporateoutstation;